/***
 * @Authors:
 *      Rahul
 *      Nikhil Chougule
 ***/

/*** Imports ***/

/* Library imports */
import React from "react";
import PropTypes from 'prop-types';

/* Style imports */
import './styles.css'

/*** End Imports ***/

const LoadingViewGetMoreProfile = (props) => {

    // helper function
    // event handlers for static component

    return (
        <div>
            <div className = "animated-background"
                 style={{height: 'fit-content',
                     flex : "1",
                     position : "relative",
                     minWidth : "340px",
                     marginRight : "0px"
                 }}
            >

                <div style={{paddingTop: '0'}}>
                    <div className="background-masker gmp-top">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker gmp-bottom">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker gmp-boost-left">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker gmp-boost-right">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker gmp-db-right">
                        <div className="background-masker-fix-content"/>
                    </div>
                    <div className="background-masker gmp-boost-bottom">
                        <div className="background-masker-fix-content"/>
                    </div>
                </div>
                <div style={{paddingTop: '652px'}}></div>
            </div>
        </div>

    );
};

/**
 * all prop types which can be passed to this component
 */
LoadingViewGetMoreProfile.propTypes = {

};

/**
 * Only if default initialization is required
 * Default props value for this component
 */
LoadingViewGetMoreProfile.defaultProps ={

};

export default LoadingViewGetMoreProfile;


// WEBPACK FOOTER //
// ./src/components/GetMoreProfilesModal/Components/LoadingView/LoadingViewGetMoreProfile/LoadingViewGetMoreProfile.js